export default __webpack_public_path__ + "static/media/work-7c.4ca3944e.png";